import { AccountData, EventType } from "@markit/common.types";
import { Icon } from "@iconify/react";
import { Colors } from "../../../utils/colors";
import EmptyStateButton from "../../Buttons/EmptyStateButton";
import { ThemeStyle } from "../../../hooks/useTheme";
import { isDesktop } from "react-device-detect";
import RectangleButton from "../../Buttons/RectangleButton";
import { getPossessiveName, isProductSpecificType } from "@markit/common.utils";
import { useNavigate } from "react-router-dom";
import { onProfilePageNavigatePath } from "../../../utils/navigationUtils";
import ProfilePic from "../../ProfilePic";

type InactiveProductStateProps = {
  eventType: EventType;
  host: AccountData;
  theme?: ThemeStyle;
};

// Used to display the inactive state of a product on the viewing screen
const InactiveProductState = (props: InactiveProductStateProps) => {
  const { eventType, host, theme } = props;
  const navigate = useNavigate();

  return (
    <div>
      <EmptyStateButton
        title={`This ${
          isProductSpecificType(eventType)
            ? "product"
            : eventType === EventType.GENERIC_LINK
            ? "form"
            : "link"
        } is inactive`}
        description={`This ${
          eventType === EventType.GENERIC_LINK
            ? "form is no longer accepting responses"
            : "link is no longer active"
        }. Contact ${
          host.fullName
        } if you have questions or believe there has been a mistake.`}
        icon={
          <Icon
            icon={"ion:hourglass"}
            height={60}
            style={{ color: Colors.GRAY1 }}
          />
        }
        iconBackgroundColor={theme?.SecondaryBG.backgroundColor || Colors.WHITE}
        iconBox={70}
        theme={theme}
      />
      <div style={{ paddingInline: isDesktop ? 0 : 24 }}>
        <RectangleButton
          buttonLabel={
            <span className="bodySmallMedium" style={{ fontWeight: 600 }}>
              Visit {getPossessiveName(host.fullName)} profile
            </span>
          }
          onPress={() => onProfilePageNavigatePath(navigate, host.username)}
          theme={theme}
          altBorderRadius={100}
          altColor={Colors.BLACK}
          altTextColor={theme?.ButtonText.color || Colors.WHITE}
          iconLeft={
            <div>
              <ProfilePic user={host} size={31} />
            </div>
          }
          altPaddingHorz={7}
          containerStyles={{ height: 44, width: "auto", margin: "auto" }}
          iconRight={
            <div>
              <Icon
                icon="tabler:arrow-up-right"
                height={15}
                style={{ marginBottom: -3, ...theme?.ButtonText }}
              />
            </div>
          }
        />
      </div>
    </div>
  );
};

export default InactiveProductState;
